export default "__VITE_ASSET__CyBFh4Vu__"